import { Component, Input, OnInit } from '@angular/core';

@Component({
	selector: 'login-sidebar',
	templateUrl: './login-sidebar.component.html',
	styleUrls: ['./login-sidebar.component.scss'],
})
export class LoginSidebarComponent implements OnInit {
	constructor() {	}

	@Input('tagLine') tagLine = '';
	public imageNumber: number;

	ngOnInit() {
		this.pickRandomImage();
	 }

	 pickRandomImage(): void {
		const nr = Math.ceil(Math.random() * 3);
		// fixed tagline for Percy
		this.imageNumber = ((window as any)?.Cypress) ? 1 : nr;
	 }
}
